<script setup lang="ts">
import { ScanState, ScanTarget } from '@/models/Scan'
import { onMounted, onUnmounted } from 'vue'
import FadeTransition from '../FadeTransition.vue'

const props = defineProps({
  target: {
    type: String,
    default: ScanTarget.Container,
  },
  state: {
    type: String,
    default: ScanState.Scanning,
  },
})
const emit = defineEmits(['barcode-scanned'])

let value = ''

const onKeydown = (event: KeyboardEvent) => {
  if (event.key === 'Shift' || event.key === 'Unidentified') return
  console.log('onKeydown', event)

  if (event.key === 'Enter') {
    event.preventDefault()
    emit('barcode-scanned', value)
    value = ''
  } else {
    value += event.key
  }
}

onMounted(() => {
  console.log('Add keydown event listener')
  document.addEventListener('keydown', onKeydown)
})
onUnmounted(() => {
  console.log('Remove keydown event listener')
  document.removeEventListener('keydown', onKeydown)
})
</script>

<template>
  <div class="zebra-scanner">
    <FadeTransition>
      <img
        src="./assets/zebra-room-scanned.svg"
        class="Local scanné"
        v-if="props.target === ScanTarget.Room && props.state === ScanState.Scanned"
      />
      <img
        src="./assets/zebra-scan-room.gif"
        class="Scan de local"
        v-else-if="props.target === ScanTarget.Room"
      />
      <img
        src="./assets/zebra-scan-scale.gif"
        class="Scan de balance"
        v-else-if="props.target === ScanTarget.Scale"
      />
      <img
        src="./assets/zebra-scan-multiple.gif"
        class="Scan de local ou de bac"
        v-else-if="props.target === ScanTarget.Multiple"
      />
      <img src="./assets/zebra-scan-container.gif" class="Scan de bac" v-else />
    </FadeTransition>
  </div>
</template>

<style scoped lang="scss">
.zebra-scanner {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    display: block;
    max-width: 85%;
    max-height: 60%;
  }
}
</style>
